module.exports = __webpack_public_path__ + "media/assets/politics-app-cta.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/media/assets/politics-app-cta.png
 ** module id = 33
 ** module chunks = 0
 **/